module.exports = __webpack_public_path__ + "img/checklist.f30b8d6d.svg";